// extracted by mini-css-extract-plugin
export default {"subTitle":"SubTitle_subTitle__kMkxs"};